<script setup>
import { onMounted, watch, ref, computed } from 'vue'
import { useRoute } from 'vue-router';
import { useAssessmentsStore } from '../stores';
import { shortDate } from '../helpers/utils'
import MilestoneReview from '../components/MilestoneReview.vue';

const route = useRoute()
const assessmentStore = useAssessmentsStore()
const assessmentData = ref(null)
const currentChild = ref({})

watch(route, async (to, prev) => {
    if (to.path.includes('readiness/assessment') && to.params.id) {
        await configureAssessmentData(to.params.id)
    }
})

const configureAssessmentData = async (assessmentId) => {
    if (!assessmentStore.readinessAssessments[assessmentId] || !assessmentStore.readinessAssessments[assessmentId].assessment_milestones) {
        await assessmentStore.fetchAssessmentById(assessmentId)
    }
    const assessmentReportCardId = assessmentStore.readinessAssessments[assessmentId].readiness_report_card_id
    assessmentData.value = assessmentStore.readinessAssessments[assessmentId]

    currentChild.value = assessmentStore.readinessReportCards[assessmentReportCardId].child
}

onMounted(async () => {
    await configureAssessmentData(route.params.id)
})

const mappedMilestones = computed(() => {
  // TODO: consolidate before making changes
    if (assessmentData.value) {
        const notesMap = assessmentData.value.assessment_notes ? assessmentData.value.assessment_notes.reduce((accum, curr) => {
            accum[curr.assessment_milestone_id] = curr
            return accum
        }, {}) : {}
        return assessmentData.value.assessment_milestones.map(milestone => {
            return {
                milestone,
                note: notesMap[milestone.id]
            }
        })
    }
})

const assessmentNote = computed(() => {
    if (assessmentData.value && assessmentData.value.assessment_notes) {
        const filtered = assessmentData.value.assessment_notes.filter(note => note.assessment_milestone_id === null)
        return filtered.length ? filtered[0].content : null
    } else return null
})

</script>
<template>
  <div v-if="assessmentData" >
    <MilestoneReview 
        :milestones="mappedMilestones"
        :title="assessmentData.readiness_area.attributes.title.replace('Development', 'Milestones')"
        :completed-at="shortDate(assessmentData.completed_at)"
        :readiness-assessment-id="assessmentData.id"
        :assessment-note="assessmentNote"
        />
  </div>
</template>